"use client";

import { usePathname } from "next/navigation";
import { Sidebar } from "@/components/sidebar";
import { MobileSidebar } from "@/components/mobile-sidebar";

/**
 * The page frame, same as the esal ERP: the navigation rail sits on the
 * canvas, and the page lives in a rounded card panel that scrolls on its own.
 * PageHeader sticks to the top of that panel. The login page has no frame.
 */
export function AppShell({
  role,
  username,
  userId,
  children,
}: {
  role?: string;
  username?: string;
  userId?: string;
  children: React.ReactNode;
}) {
  const pathname = usePathname();
  if (pathname === "/login") return <div className="bg-background min-h-dvh">{children}</div>;

  return (
    <div className="bg-background text-foreground flex h-dvh gap-2 overflow-hidden p-2 print:block print:h-auto print:overflow-visible print:bg-white print:p-0">
      <aside className="nav-scroll relative hidden w-60 shrink-0 overflow-y-auto md:flex print:hidden">
        <Sidebar role={role} username={username} userId={userId} />
      </aside>

      <div className="flex min-h-0 min-w-0 flex-1 flex-col gap-2 overflow-hidden print:block print:overflow-visible">
        <div className="flex h-10 shrink-0 items-center md:hidden print:hidden">
          <MobileSidebar role={role} username={username} userId={userId} />
        </div>
        <main className="bg-card border-border relative flex min-h-0 flex-1 flex-col overflow-hidden rounded-2xl border dark:border-0 dark:shadow-lg print:block print:overflow-visible print:rounded-none print:border-0 print:bg-white print:shadow-none">
          <div id="page-scroll" className="relative min-h-0 flex-1 overflow-auto print:overflow-visible">
            <div className="flex min-h-full flex-col px-4 pb-6 md:px-6 print:p-0">{children}</div>
          </div>
        </main>
      </div>
    </div>
  );
}
